import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickSingleQuery } from "../../../types";
import { getApi } from "../../../apiPath";
import { axiosClient } from "../../../clients";

import type { IMembersScopusCandidate } from "./routeType";

const { key, getPath } = getApi("members.scopus.candidate.get");

type IExtractedRouteType =
  IMembersScopusCandidate["memberProfileSingleCandidateScopusDataCollectionRetrieve"];

export type IGetMemberScopusCandidate = IPickSingleQuery<IExtractedRouteType>;

const getMemberScopusCandidate: Fetcher<
  IGetMemberScopusCandidate["response"],
  IGetMemberScopusCandidate["variables"]
> = ({ memberId, ...params }) => {
  return axiosClient.get(getPath({ memberId }), { params });
};

export const useGetMemberScopusCandidate = createQuery({
  queryKey: [key],
  fetcher: getMemberScopusCandidate,
});
